module.exports = __webpack_public_path__ + "static/19-c8341059789ed59f09c90327061ccb0d.jpg";